module.exports = __webpack_public_path__ + "assets/img/2fcb2b3bc0fac8b663e29f419414ea1e.svg";